const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const parseRegistrationTimestamp = (value) => {
    if (typeof value === 'number') {
        return value;
    }

    if (typeof value !== 'string') {
        return Number.NaN;
    }

    const normalizedValue = value.trim();
    if (!normalizedValue) {
        return Number.NaN;
    }

    if (/^\d+$/.test(normalizedValue)) {
        return Number(normalizedValue);
    }

    return Date.parse(normalizedValue);
};

export const isRegistrationOlderThanOneWeek = (value, now = Date.now()) => {
    const registrationTimestamp = parseRegistrationTimestamp(value);

    return Number.isFinite(registrationTimestamp)
        && registrationTimestamp < now - ONE_WEEK_MS;
};

export const shouldUseLegacyProPricing = ({ user, registrationCookie, now = Date.now() }) => {
    const registrationDate = user
        ? user.created_at
        : registrationCookie;

    return isRegistrationOlderThanOneWeek(registrationDate, now);
};
